module.exports = __webpack_public_path__ + "files/107d2c558df6b7a08db579584f0fd118.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/people_body-1.png
// module id = 492
// module chunks = 76